import '@material/web/icon/icon.js'
import '@operato/input/ox-input-search.js'

import { css, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { openHelp } from '@operato/help'
import { RouteController } from '@operato/shell'

@customElement('ox-title-bar')
export class TitleBar extends LitElement {
  static styles = [
    css`
      :host {
        display: flex;
        align-items: center;
        text-transform: capitalize;

        --help-icon-color: var(--md-sys-color-primary);
        --help-icon-hover-color: var(--md-sys-color-primary);
        --help-icon-opacity: 0.2;
        --help-icon-size: 20px;

        --md-icon-size: 20px;

        --input-search-padding: var(--spacing-medium);
        --input-search-focus-border-bottom: none;
        --input-search-font: normal 16px var(--theme-font);
      }

      [titler] {
        display: flex;
        font: var(--context-toolbar-title);
      }

      [titler] > * {
        align-self: center;
      }

      [help] {
        opacity: 0.5;
        font-size: var(--help-icon-size);
        color: var(--context-toolbar-title);
      }

      [help]:hover {
        cursor: help;
        opacity: var(--help-icon-hover-opacity);
        color: var(--help-icon-hover-color);
      }

      [search] {
        display: flex;
        justify-content: space-between;
        align-items: center;

        align-self: center;
        color: var(--md-sys-color-primary);
        background-color: var(--md-sys-color-on-primary);
        border-radius: var(--md-sys-shape-corner-full);
        padding: 0 var(--spacing-medium);
      }

      [search] > * {
        align-self: center;
      }

      ox-input-search {
        color: var(--md-sys-color-primary);
        background-color: transparent;
        border-radius: var(--md-sys-shape-corner-full);
      }
    `
  ]

  private _route = new RouteController(this)

  render() {
    var { search, filter, title, help } = this._route.context || ({} as any)
    var { value = '', handler: searchHandler, placeholder = '', autofocus = true, maxLength } = search || ({} as any)
    const { handler: filterHandler } = filter || ({} as any)
    const { icon, text = title } = typeof title === 'object' ? title : ({} as any)
    const searchable = typeof searchHandler == 'function'
    const filterable = typeof filterHandler == 'function'

    if (searchable && title) {
      placeholder ||= text
      title = ''
    }

    return html`
      ${title ? html` <div titler>${icon ? html`<md-icon>${icon}</md-icon>&nbsp;` : html``}${text}</div> ` : html``}
      ${help && title ? html` &nbsp;<md-icon @click=${(e: MouseEvent) => openHelp(help)} help>help</md-icon> ` : html``}
      ${searchable || filterable
        ? html`
            <div search>
              ${searchable
                ? html` <ox-input-search
                    .placeholder=${placeholder}
                    .value=${value || ''}
                    ?autofocus=${autofocus}
                    .maxLength=${maxLength}
                    @change=${(e: Event) => {
                      searchHandler((e.target as any).value)
                    }}
                  ></ox-input-search>`
                : html``}
              ${!title && help && searchable
                ? html`<md-icon @click=${(e: MouseEvent) => openHelp(help)} help>help</md-icon>`
                : html``}
              ${filterable ? html`<md-icon @click=${(e: MouseEvent) => filterHandler()}>tune</md-icon>` : html``}
            </div>
          `
        : html``}
    `
  }
}
